export default "__VITE_ASSET__ace08dff__"